import { getMenuFeatures } from "../utils/media"

export const MODULES = {
    SETTINGS: "settings",
    COMMUNICATION: "comm",
    CALENDAR: "roaster"
}

export const FEATURE = {
    POPNOTIFICATION: "POPNOTIFICATION",
    EDITHTML: "EDITHTML"
}